export default __webpack_public_path__ + "static/media/RadicalSpaces2021.9bf4df74.pdf";